
import React, {Component} from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button
} from 'reactstrap';
import MarkDown from 'react-markdown';

class ConfirmDialog extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} className={"modal-" + this.props.className}>
        <ModalHeader toggle={this.props.toggle}>{this.props.title}</ModalHeader>
        <ModalBody>
          <MarkDown source={this.props.body} />
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={() => this.props.callback('Y', this.props.item)}>OK</Button>
          <Button color="secondary" onClick={() => this.props.callback('N')}>Cancel</Button>
        </ModalFooter>
      </Modal>
    )
  }
}

ConfirmDialog.defaultProps = {
  isOpen: false,
  toggle: () => {},
  callback: (answer) => {},
  className: "",
  title: "Confirm",
  body: "",
  item: null
};

export default ConfirmDialog;


// WEBPACK FOOTER //
// ./src/components/ConfirmDialog/ConfirmDialog.js